var SupportEmailSuccessView, SupportTicketSuccessView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportTicketSuccessView = require('./ticket_success_view');

SupportEmailSuccessView = (function(superClass) {
  extend(SupportEmailSuccessView, superClass);

  function SupportEmailSuccessView() {
    return SupportEmailSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportEmailSuccessView.prototype.toHash = function() {
    var hash;
    hash = SupportTicketSuccessView.prototype.toHash.call(this);
    hash.showDefaultThankYouMsg = false;
    hash.showEmailThankYouMsg = true;
    hash.showNeedHelpLink = true;
    return hash;
  };

  SupportEmailSuccessView.prototype.shouldShowFooter = function() {
    return false;
  };

  SupportEmailSuccessView.prototype.getGreetingText = function() {
    if (this.isRefundEligible()) {
      return I18n.translate('js.modules.support.request_submitted_successfully');
    } else {
      return I18n.translate('js.modules.support.v2.thanks_email');
    }
  };

  return SupportEmailSuccessView;

})(SupportTicketSuccessView);

module.exports = SupportEmailSuccessView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfc3VjY2Vzc192aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX3N1Y2Nlc3Nfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxpREFBQTtFQUFBOzs7QUFBQSx3QkFBQSxHQUEyQixPQUFBLENBQVEsdUJBQVI7O0FBRXJCOzs7Ozs7O29DQUVKLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsR0FBTyx3QkFBd0IsQ0FBQSxTQUFFLENBQUEsTUFBTSxDQUFDLElBQWpDLENBQXNDLElBQXRDO0lBQ1AsSUFBSSxDQUFDLHNCQUFMLEdBQThCO0lBQzlCLElBQUksQ0FBQyxvQkFBTCxHQUE2QjtJQUM3QixJQUFJLENBQUMsZ0JBQUwsR0FBd0I7V0FDeEI7RUFMTTs7b0NBT1IsZ0JBQUEsR0FBa0IsU0FBQTtXQUNqQjtFQURpQjs7b0NBR2xCLGVBQUEsR0FBaUIsU0FBQTtJQUNmLElBQUcsSUFBQyxDQUFBLGdCQUFELENBQUEsQ0FBSDthQUNFLElBQUksQ0FBQyxTQUFMLENBQWUsbURBQWYsRUFERjtLQUFBLE1BQUE7YUFHRSxJQUFJLENBQUMsU0FBTCxDQUFlLG9DQUFmLEVBSEY7O0VBRGU7Ozs7R0Fab0I7O0FBa0J2QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
